import { Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { MainLayout } from '@/shared/components/layout'
import { useAuth } from '@/shared/contexts/AuthContext'
import { useUnit } from '@/modules/units/contexts/UnitContext'
import { getProfile } from '@/modules/profile'
import { BatchesPage } from './BatchesPage'
import { PlaceholderPage } from '@/app/pages/PlaceholderPage'
import { PoultryDashboard } from '@/modules/poultry/Dashboard'
import { useResolveContextUnit } from '@/modules/units/useResolveContextUnit'

export default function PoultryLayout() {
  const { user } = useAuth()
  const { currentUnit, isLoading: unitLoading, setCurrentUnit: switchUnit } = useUnit()
  const [profile, setProfile] = useState<any | null>(null)
  const { ready, resolving } = useResolveContextUnit('poultry')

  useEffect(() => {
    if (!user?.id) return
    getProfile(user.id)
      .then(setProfile)
      .catch((err) => console.error('Error loading profile in PoultryLayout', err))
  }, [user?.id])

  // Unit resolution is handled by useResolvePoultryUnit

  if (unitLoading || resolving || !ready) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-amber-500 border-r-transparent" />
      </div>
    )
  }

  return (
    <MainLayout
      userName={profile?.full_name || user?.email}
      userId={user?.id}
      currentUnitId={profile?.current_unit_id || null}
    >
      <Routes>
        <Route index element={<PoultryDashboard />} />
        <Route path="batches" element={<BatchesPage />} />
        <Route path="egg-production" element={<PlaceholderPage title="Produção de Ovos" />} />
        <Route path="mortalities" element={<PlaceholderPage title="Mortalidades" />} />
        <Route path="feed" element={<PlaceholderPage title="Rações" />} />
        <Route path="feed/purchases" element={<PlaceholderPage title="Compras de Ração" />} />
        <Route path="feed/consumption" element={<PlaceholderPage title="Consumo de Ração" />} />
        <Route path="medications" element={<PlaceholderPage title="Medicamentos e Vacinas" />} />
        <Route path="medication-schedules" element={<PlaceholderPage title="Agenda Sanitária" />} />
        <Route path="slaughters" element={<PlaceholderPage title="Abates / Vendas" />} />
        <Route path="veterinary-visits" element={<PlaceholderPage title="Visitas Veterinárias" />} />
        <Route path="registrations" element={<PlaceholderPage title="Cadastros" />} />
        <Route path="registrations/breeds" element={<PlaceholderPage title="Raças" />} />
        <Route path="registrations/products" element={<PlaceholderPage title="Produtos / Insumos" />} />
        <Route path="registrations/package-sizes" element={<PlaceholderPage title="Tamanhos de Embalagem" />} />
        <Route path="reports" element={<PlaceholderPage title="Relatórios" />} />
        <Route path="settings" element={<PlaceholderPage title="Configurações" />} />
      </Routes>
    </MainLayout>
  )
}
